import React, { Component } from 'react';
import { connect } from 'react-redux';
import Notice from '../containers/Notice';
import { Redirect } from 'react-router';
import { withRouter } from "react-router-dom";
import { authCheck, logoutUser } from '../../actions/authActions';

import { Layout as  LayoutAntd, Button, Popconfirm, message, Avatar } from 'antd';

const { Header, Footer, Content  } = LayoutAntd;


class Layout extends Component {
    componentWillMount(){
        this.props.authCheck();
    }

    confirm(e) {
        message.info('До новых встреч!');
        setTimeout(()=>{
            this.props.logoutUser();
        },1000)
    }
      
    cancel(e) {
        message.info('Ок, продолжаем работу');
    }

    render() {
        return (
            <LayoutAntd>
                {!this.props.auth.loggedIn && this.props.location.pathname !== '/auth' ? <Redirect to="/auth" /> : ''} 
                {/*auth_expired && this.props.location.pathname !== '/auth' ? this.props.logout() : ''*/}
                <Notice />
                <Header style={{ background: '#fff', padding: 0 }}>

                {this.props.auth.loggedIn ?
                <Popconfirm title="Разлогиниваемся, уверены?" placement="rightBottom" onConfirm={this.confirm.bind(this)} onCancel={this.cancel.bind(this)} okText="Да" cancelText="Нет">
                    <Avatar style={{ backgroundColor: this.props.auth.admin == 'Y' ? '#f56a00':'#87d068' }}  size="large">{this.props.auth.admin == 'Y' ? 'admin':'user'}</Avatar>  <Button className="warning"  icon="logout" style={{ textAlign: 'right'}} size="small">{this.props.auth.email}</Button>
                </Popconfirm>
                : null}

                </Header>
                <Content style={{ background: '#fff', padding: 0 }}>{ this.props.children }</Content>
                <Footer style={{ textAlign: 'center', bottom:'0', position:'fixed', width:'100%' }}>
                    © ООО «Видеомакс» 2011-2018 created by Macte
                </Footer>
            </LayoutAntd>
        );
    }
}

const mapStateToProps = (state) => ({
    auth: state.auth,
})

const mapDispatchToProps = dispatch => ({
    authCheck: payload => dispatch(authCheck()),
    logoutUser: () => dispatch(logoutUser())
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Layout));


// WEBPACK FOOTER //
// ./src/components/layouts/Layout.js